import React from "react";
export default class AboutUsSection extends React.Component {
  render() {
    return (
      <section
        id="about-section"
        className="section profile-section aboutsection  d-flex align-items-center text-center"
      >
        <div className="container">
          <h2>
            <span className="red">PROFILE</span>
            ABOUT CP FOOD
          </h2>
          <p>
            CP Food Service is a privately owned food service company located
            conveniently in the inner West of Sydney, New South Wales. We import
            and distribute an extensive range of food products ranging from
            vegetable oils, rice, noodles, condiments, sauces, pastes, seafood,
            detergents, packaging and more.
          </p>
          <p>
            Our clientele include local restaurants, takeaway shops, cafés,
            hotels, clubs, supermarkets & wholesalers. With the help of our
            dedicated team and fleet of trucks, we endeavour to ensure that our
            clients can rely on us for timely and reliable orders.
          </p>
          <p>
            Not only do we stock major national brands and international brands
            from the Asia Pacific, we continually look to update our product
            range to keep up with our customer requirements and market trends.
            With our many years of experience we have created our own product
            lines that our customers choose to use.
          </p>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/AboutUs-Section.js